import React, {
  useEffect,
  useState,
} from "react";

import {
  useTranslation,
} from "react-i18next";

import {
  useDispatch,
  useSelector,
} from "react-redux";

import axios from "axios";

import {
  motion,
} from "framer-motion";

import {
  FiImage,
  FiPlus,
  FiRefreshCw,
  FiCheckCircle,
  FiTag,
} from "react-icons/fi";

import {
  MdOutlineLocalOffer,
} from "react-icons/md";

import {
  useStateContext,
} from "../../context/ContextProvider";

import {
  DLabel,
  Select,
  DSpinButton,
  TextArea,
} from "../utils/Form";

import {
  getAllCategorys,
} from "../../redux/actions/category";

import {
  toast,
} from "react-toastify";

import {
  Loader,
} from "../utils";

import {
  BaseUrl,
} from "../../server";

import ImageUploadWithResize
  from "../../utils/ImageUploadWithResize";


function CreateFeaturedMeals() {
  const {
    t,
  } = useTranslation();

  const {
    currentColor,
  } = useStateContext();

  const dispatch =
    useDispatch();


  /* =====================================
      REDUX
  ====================================== */

  const {
    isLoading,
    AllCategorys,
  } = useSelector(
    (state) =>
      state.Categorys
  );


  /* =====================================
      STATES
  ====================================== */

  const [
    isSpinner,
    setIsSpinner,
  ] = useState(false);


  const [
    titleAr,
    setTitleAr,
  ] = useState("");


  const [
    titleEn,
    setTitleEn,
  ] = useState("");


  const [
    textAr,
    setTextAr,
  ] = useState("");


  const [
    textEn,
    setTextEn,
  ] = useState("");


  const [
    categoryId,
    setCategoryId,
  ] = useState("");


  const [
    price,
    setPrice,
  ] = useState("");


  const [
    image,
    setImage,
  ] = useState(null);


  const [
    imageShow,
    setImageShow,
  ] = useState(null);


  /*
   * لإعادة إنشاء مكون رفع الصورة
   * بعد نجاح الإضافة أو الضغط على Reset.
   */

  const [
    uploadKey,
    setUploadKey,
  ] = useState(0);


  /* =====================================
      GET CATEGORIES
  ====================================== */

  useEffect(() => {
    dispatch(
      getAllCategorys()
    );
  }, [
    dispatch,
  ]);


  /* =====================================
      RESET FORM
  ====================================== */

  const resetForm = () => {
    setTitleAr("");
    setTitleEn("");

    setTextAr("");
    setTextEn("");

    setCategoryId("");

    setPrice("");

    setImage(null);
    setImageShow(null);

    setUploadKey(
      (prev) =>
        prev + 1
    );
  };


  /* =====================================
      VALIDATION
  ====================================== */

  const validateForm = () => {

    if (
      !titleAr.trim()
    ) {
      toast.error(
        t(
          "Arabic title is required"
        )
      );

      return false;
    }


    if (
      !titleEn.trim()
    ) {
      toast.error(
        t(
          "English title is required"
        )
      );

      return false;
    }


    if (
      !categoryId
    ) {
      toast.error(
        t(
          "Please select a category"
        )
      );

      return false;
    }


    if (
      !textAr.trim()
    ) {
      toast.error(
        t(
          "Arabic description is required"
        )
      );

      return false;
    }


    if (
      !textEn.trim()
    ) {
      toast.error(
        t(
          "English description is required"
        )
      );

      return false;
    }


    if (!image) {
      toast.error(
        t(
          "Please select an image"
        )
      );

      return false;
    }


    if (
      price !== "" &&
      Number(price) < 0
    ) {
      toast.error(
        t(
          "Price cannot be negative"
        )
      );

      return false;
    }


    return true;
  };


  /* =====================================
      CREATE FEATURED MEAL
  ====================================== */

  const handleSubmit =
    async (e) => {

      e.preventDefault();


      if (
        isSpinner
      ) {
        return;
      }


      if (
        !validateForm()
      ) {
        return;
      }


      try {
        setIsSpinner(
          true
        );


        /* =============================
            FORM DATA
        ============================== */

        const newForm =
          new FormData();


        newForm.append(
          "file",
          image
        );


        newForm.append(
          "categoryId",
          categoryId
        );


        newForm.append(
          "titleAr",
          titleAr.trim()
        );


        newForm.append(
          "titleEn",
          titleEn.trim()
        );


        newForm.append(
          "textAr",
          textAr.trim()
        );


        newForm.append(
          "textEn",
          textEn.trim()
        );


        if (
          price !== ""
        ) {
          newForm.append(
            "price",
            Number(price)
          );
        }


        /* =============================
            REQUEST
        ============================== */

        const config = {
          headers: {
            "Content-Type":
              "multipart/form-data",
          },

          withCredentials:
            true,
        };


        const {
          data,
        } = await axios.post(
          `${BaseUrl}/featuredMeals/create`,

          newForm,

          config
        );


        /* =============================
            SUCCESS
        ============================== */

        if (
          data?.success
        ) {

          toast.success(
            <div
              className="
                flex
                items-center

                gap-2

                font-kufi
                text-sm
              "
            >
              <FiCheckCircle />

              <span>
                {t(
                  "Featured Meal created successfully!"
                )}
              </span>
            </div>
          );


          resetForm();

        }

      } catch (error) {

        const errorMessage =
          error?.response
            ?.data?.message ||
          error?.message ||
          t(
            "An error occurred"
          );


        toast.error(
          <span
            className="
              font-kufi
              text-sm
            "
          >
            {errorMessage}
          </span>
        );

      } finally {

        setIsSpinner(
          false
        );

      }
    };


  /* =====================================
      LOADING
  ====================================== */

  if (isLoading) {
    return <Loader />;
  }


  return (
    <motion.div
      initial={{
        opacity: 0,
        y: 25,
      }}

      animate={{
        opacity: 1,
        y: 0,
      }}

      transition={{
        duration: 0.55,
      }}

      className="
        w-full

        max-w-[1050px]

        mx-auto
      "
    >

      {/* =====================================
          INTRO HERO
      ====================================== */}

      <section
        className="
          relative

          overflow-hidden

          rounded-[2rem]

          bg-color-2

          px-6
          py-7

          md:px-8
          md:py-8

          mb-6

          text-white

          shadow-[0_18px_50px_rgba(68,37,20,.16)]
        "
      >

        {/* Decorative Glow */}

        <div
          className="
            absolute

            -top-24
            -end-20

            w-64
            h-64

            rounded-full

            bg-color-1/20

            blur-[90px]

            pointer-events-none
          "
        />


        <div
          className="
            absolute

            -bottom-24
            start-20

            w-52
            h-52

            rounded-full

            bg-color-1/10

            blur-[80px]

            pointer-events-none
          "
        />


        <div
          className="
            relative
            z-10

            flex
            flex-col

            md:flex-row
            md:items-center
            md:justify-between

            gap-5
          "
        >

          {/* Intro */}

          <div
            className="
              flex
              items-start

              gap-4
            "
          >

            <div
              className="
                flex

                w-14
                h-14

                shrink-0

                items-center
                justify-center

                rounded-2xl

                bg-color-1

                text-2xl
                text-white

                shadow-[0_10px_30px_rgba(165,119,58,.28)]
              "
            >
              <MdOutlineLocalOffer />
            </div>


            <div>

              <span
                className="
                  font-kufi
                  text-[10px]
                  md:text-xs

                  text-color-1
                "
              >
                {t(
                  "Offers Management"
                )}
              </span>


              <h1
                className="
                  mt-1

                  font-kufi
                  font-bold

                  text-2xl
                  md:text-3xl

                  text-white
                "
              >
                {t(
                  "Create Offer"
                )}
              </h1>


              <p
                className="
                  max-w-xl

                  mt-2

                  font-kufi
                  text-xs
                  md:text-sm

                  leading-7

                  text-white/55
                "
              >
                {t(
                  "Create a featured meal or special offer to highlight it for Yaman customers"
                )}
              </p>

            </div>

          </div>


          {/* Reset */}

          <motion.button
            type="button"

            whileTap={{
              scale: 0.97,
            }}

            onClick={
              resetForm
            }

            disabled={
              isSpinner
            }

            className="
              flex

              min-h-[44px]

              items-center
              justify-center

              gap-2

              rounded-full

              border
              border-white/15

              bg-white/10

              px-4

              font-kufi
              text-xs

              text-white

              backdrop-blur-md

              transition-all

              hover:bg-white
              hover:text-color-2

              disabled:opacity-50
            "
          >
            <FiRefreshCw />

            {t(
              "Reset Form"
            )}
          </motion.button>

        </div>

      </section>


      {/* =====================================
          FORM CARD
      ====================================== */}

      <section
        className="
          overflow-hidden

          rounded-[2rem]

          border
          border-color-2/10
          dark:border-white/10

          bg-back-primery
          dark:bg-back-darksecondary

          shadow-[0_15px_45px_rgba(68,37,20,.07)]
        "
      >

        {/* =================================
            CARD HEADER
        ================================= */}

        <div
          className="
            flex
            items-center

            gap-4

            px-5
            md:px-8

            py-5
            md:py-6

            border-b
            border-color-2/10
            dark:border-white/10
          "
        >

          <div
            className="
              flex

              w-11
              h-11

              shrink-0

              items-center
              justify-center

              rounded-2xl

              bg-color-1/10

              text-color-1
            "
          >
            <FiTag />
          </div>


          <div>

            <h2
              className="
                font-kufi
                font-semibold

                text-base
                md:text-lg

                text-tcolor-4
                dark:text-white
              "
            >
              {t(
                "Offer Information"
              )}
            </h2>


            <p
              className="
                mt-1

                font-kufi
                text-[10px]
                md:text-xs

                text-n-5
                dark:text-white/35
              "
            >
              {t(
                "Enter the offer information in Arabic and English"
              )}
            </p>

          </div>

        </div>


        {/* =================================
            FORM
        ================================= */}

        <form
          onSubmit={
            handleSubmit
          }

          className="
            p-5
            md:p-8
          "
        >

          {/* =================================
              TITLES
          ================================= */}

          <div
            className="
              grid

              grid-cols-1
              md:grid-cols-2

              gap-x-5
            "
          >

            <DLabel
              labelText="Title (Ar)"

              value={
                titleAr
              }

              onChange={(
                e
              ) =>
                setTitleAr(
                  e.target.value
                )
              }

              required={
                true
              }

              type="text"

              name="titleAr"
            />


            <DLabel
              labelText="Title (En)"

              value={
                titleEn
              }

              onChange={(
                e
              ) =>
                setTitleEn(
                  e.target.value
                )
              }

              required={
                true
              }

              type="text"

              name="titleEn"
            />

          </div>


          {/* =================================
              PRICE + CATEGORY
          ================================= */}

          <div
            className="
              mt-2

              grid

              grid-cols-1
              md:grid-cols-2

              gap-x-5

              items-start
            "
          >

            <DLabel
              labelText="Price"

              value={
                price
              }

              onChange={(
                e
              ) =>
                setPrice(
                  e.target.value
                )
              }

              required={
                false
              }

              type="number"

              name="price"

              min="0"
            />


            <Select
              Data={
                AllCategorys ||
                []
              }

              labelText={t(
                "Select Category"
              )}

              value={
                categoryId
              }

              setValue={
                setCategoryId
              }

              required={
                true
              }
            />

          </div>


          {/* =================================
              DESCRIPTIONS
          ================================= */}

          <div
            className="
              mt-5

              rounded-[1.5rem]

              border
              border-color-2/10
              dark:border-white/10

              bg-back-secondary/50
              dark:bg-back-darkprimery/50

              p-4
              md:p-5
            "
          >

            <div
              className="
                flex
                items-center

                gap-3

                mb-4
              "
            >

              <span
                className="
                  w-7
                  h-[2px]

                  rounded-full

                  bg-color-1
                "
              />


              <span
                className="
                  font-kufi
                  font-semibold

                  text-xs

                  text-color-1
                "
              >
                {t(
                  "Offer Description"
                )}
              </span>

            </div>


            <TextArea
              labelText={t(
                "Description (Ar)"
              )}

              value={
                textAr
              }

              onChange={(
                e
              ) =>
                setTextAr(
                  e.target.value
                )
              }

              required={
                true
              }
            />


            <TextArea
              labelText={t(
                "Description (En)"
              )}

              value={
                textEn
              }

              onChange={(
                e
              ) =>
                setTextEn(
                  e.target.value
                )
              }

              required={
                true
              }
            />

          </div>


          {/* =================================
              IMAGE
          ================================= */}

          <div
            className="
              mt-6

              rounded-[1.5rem]

              border
              border-color-1/15

              bg-color-1/[0.035]

              p-4
              md:p-6
            "
          >

            <div
              className="
                flex
                items-center

                gap-3

                mb-5
              "
            >

              <div
                className="
                  flex

                  w-10
                  h-10

                  items-center
                  justify-center

                  rounded-xl

                  bg-color-1/10

                  text-color-1
                "
              >
                <FiImage />
              </div>


              <div>

                <h3
                  className="
                    font-kufi
                    font-semibold

                    text-sm

                    text-tcolor-4
                    dark:text-white
                  "
                >
                  {t(
                    "Offer Image"
                  )}
                </h3>


                <p
                  className="
                    mt-1

                    font-kufi
                    text-[9px]
                    md:text-[10px]

                    text-n-5
                    dark:text-white/35
                  "
                >
                  {t(
                    "Upload an attractive image that clearly represents the featured offer"
                  )}
                </p>

              </div>

            </div>


            <ImageUploadWithResize
              key={
                uploadKey
              }

              imageShow={
                imageShow
              }

              setImageShow={
                setImageShow
              }

              setImage={
                setImage
              }

              currentColor={
                currentColor
              }

              label="Upload Image"

              required={
                true
              }

              maxWidth={
                1200
              }

              maxHeight={
                1200
              }

              quality={
                82
              }
            />

          </div>


          {/* =================================
              SUBMIT AREA
          ================================= */}

          <div
            className="
              mt-8

              pt-6

              border-t
              border-color-2/10
              dark:border-white/10
            "
          >

            <DSpinButton
              isLoading={
                isSpinner
              }
            >

              <span
                className="
                  flex
                  items-center
                  justify-center

                  gap-2
                "
              >

                {!isSpinner && (
                  <FiPlus />
                )}


                {isSpinner
                  ? t(
                      "Creating..."
                    )
                  : t(
                      "Create Offer"
                    )}

              </span>

            </DSpinButton>

          </div>

        </form>

      </section>


      {/* =====================================
          TIP
      ====================================== */}

      <div
        className="
          flex
          items-start

          gap-3

          mt-5

          rounded-[1.2rem]

          border
          border-color-1/10

          bg-color-1/[0.035]

          px-4
          py-3
        "
      >

        <FiCheckCircle
          className="
            mt-1

            shrink-0

            text-color-1
          "
        />


        <p
          className="
            font-kufi
            text-[10px]
            md:text-xs

            leading-6

            text-n-5
            dark:text-white/40
          "
        >
          {t(
            "Use an appetizing image and a short clear title because featured offers receive more attention on the website"
          )}
        </p>

      </div>

    </motion.div>
  );
}


export default CreateFeaturedMeals;